<div class="card card-shadow d-flex flex-column" [class.bg-grey]="isTileDisabled">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">Run Correction Payroll</h3>
    <h6 *ngIf="appConfigService.getConfig().EnableCorrectionPayrollLanding" class="flex-grow-1">
      Void a recent payroll (more functionality coming soon).
    </h6>
    <small *ngIf="!payrollStartData?.OpenOrHeldQuarterPayrolls.length" class="flex-grow-1 mb-3">
      <strong style="color: #5e625f">*No recent payrolls available for corrections.</strong>
    </small>
    <div *ngIf="payrollStartData?.ActivePayroll && payrollStartData?.ActivePayroll?.PayType == 1">
      <h6 class="cp-green fw-bold mb-0">Entry in progress</h6>
      <small class="cp-green">
        Last edit by {{ payrollStartData.ActivePayroll.LastEditBy }} on
        {{ payrollStartData.ActivePayroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
      </small>
    </div>
    <small *ngIf="!appConfigService.getConfig().EnableCorrectionPayrollLanding">
      <em
        >Temporarily Unavailable. We are working on this feature. Please use the APS application to
        enter history voids.</em
      >
    </small>
    <button
      (click)="navigatePayroll()"
      type="button"
      [disabled]="isTileDisabled"
      class="btn btn-primary float-end mt-auto align-self-end"
      data-testid="start-adjustment-payroll-tile-btn">
      {{ buttonText }}
    </button>
  </div>
</div>
